module.exports = __webpack_public_path__ + "static/media/settings-default-avatar.839a129d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/icons/settings-default-avatar.svg
// module id = 793
// module chunks = 0